<template>
    <!-- SearchInput.vue -->
    <v-menu
        ref="menu"
        v-model="showMenu"
        :close-on-click="false"
        :max-height="height"
        :max-width="width"
        :open-on-click="false"
        offset-y
        rounded
    >
        <template v-slot:activator="{on, attrs}">
            <!-- Text Field -->
            <v-text-field
                ref="searchField"
                v-model="searchValue"
                :style="`max-width: ${width}`"
                clearable
                dense
                hide-details
                outlined
                placeholder="Search..."
                prepend-inner-icon="mdi-magnify"
                rounded
                single-line
                v-bind="attrs"
                @blur="closeMenu"
                @focus="openMenu"
                @input="openMenu"
                v-on="on"
                @keyup.esc="$refs.searchField.blur()"
                @keyup.enter="handleEnter"
                @click:clear="handleClear"
            ></v-text-field>
        </template>
        <!-- Results -->
        <search-list
            v-if="searchValue"
            :items="items"
            :limit="limit"
            :loading="loading"
            :term="searchValue"
        ></search-list>
    </v-menu>
</template>

<script>
    import {debounce, isEmpty} from 'lodash'
    // Components
    import SearchList from './SearchList'
    import {SEARCH} from '@/router/search/route-names'

    export default {
        name: 'SearchInput',
        data: () => ({
            searchValue: '',
            showMenu: false,
            initIndex: -1
        }),
        components: {
            SearchList
        },
        props: {
            /**
             * The width of the text field
             */
            width: {
                type: String,
                default: '400px'
            },
            /**
             * The height of the menu
             */
            height: {
                type: String,
                default: '80vh'
            },
            /**
             * Toggle the loading state
             */
            loading: {
                type: Boolean,
                default: false
            },
            /**
             * The number of items to show per section
             */
            limit: {
                type: Number,
                default: 5
            },
            /**
             * The search items i.e. {customer: [], cancellation: []}
             */
            items: {
                type: Object,
                required: true
            }
        },
        methods: {
            handleEnter () {
                const vm = this

                if (vm.initIndex === -1 && vm.searchValue) {
                    vm.showMenu = false
                    vm.$router.push({
                        name: SEARCH,
                        query: {
                            term: vm.searchValue
                        }
                    })
                }
            },
            handleClear () {
                /**
                 * @event clear
                 */
                this.$emit('clear')
            },
            handleSearch: debounce(function (term) {
                /**
                 * @event search
                 * @type {{term: string}}
                 */
                this.$emit('search', {term})
            }, 250),
            openMenu () {
                this.showMenu = true
            },
            closeMenu () {
                setTimeout(() => {
                    this.showMenu = false
                }, 250)
            }
        },
        watch: {
            searchValue (term) {
                const vm = this

                if (!term) {
                    return vm.handleClear()
                }

                vm.handleSearch(term)
            },
            items (newVal) {
                const vm = this
                const index = isEmpty(newVal) ? -1 : 0

                vm.$nextTick(() => {
                    vm.initIndex = index
                    vm.$refs.menu.listIndex = index
                })
            }
        }
    }
</script>
